
import { Getter, State } from 'vuex-class';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class SelectedDeceasedDonorOrganLinks extends Vue {
  @Getter('clientId', { namespace: 'deceasedDonors' }) clientId!: string|undefined;
  @Getter('isTransplantCoordinator', { namespace: 'users' }) private isTransplantCoordinator!: boolean;

  @Prop() organId!: string;
  @Prop() organ!: string;
  @Prop() organCode!: string;
  @Prop() organRoute!: any;

  show = false;

  public toggleNav() {
    this.show = !this.show;
  }

  public mounted() {
    this.show = this.isActive;
  }

  @Watch('$route', { immediate: true, deep: true })
  public onUrlChange() {
    this.show = this.isActive;
  }

  get isActive(): boolean {
    return this.organCode == this.$route.params.organ_code
      && this.organRoute.params.option == this.$route.params.option;
  }

  public toggleSideNav(): void {
    if (window.innerWidth < 992) {
      this.$emit("toggle");
    }
  }


  public getUrl(hash: string): string {
    hash = `#${hash}`;
    if(this.isActive) {
      return hash;
    } else {
      // We are fine not checking for the existence of client_id as for new recipients we only ever show this in active mode
      const location = this.$router.resolve({ name: 'deceased-donor-organ', params: { organ_code: this.organCode }, hash: hash });
      return location.href;
    }
  }
}
